import { keepPreviousData, QueryClient } from "@tanstack/react-query";

// A shared client lets auth transitions clear every account-scoped and Refine
// resource query before another user can render cached data from the last one.
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      placeholderData: keepPreviousData,
    },
  },
});

export default queryClient;
